// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EditBanner_wrapper__3Sq34","cropper":"EditBanner_cropper__30FhC","save":"EditBanner_save__2uDDj"};